<template>
  <div class="shop-rank">
    <p class="title">{{title}}</p>
    <div class="row" v-for="(item, index) in list" :key="index">
      <span class="index" :class="`rank${index}`">{{index + 1}}</span>
      <div class="content">
        <div class="tips">
          <span class="name">{{item.shop && item.shop.name || "未知商户"}}</span>
          <span class="price">
            <span>￥</span>
            <count-to :start-val='0' :decimals="2" :end-val='+convertYuan(item.count)' :duration='3000'></count-to>
          </span>
        </div>
        <el-progress :percentage="formatPercentage(item, index)" :stroke-width="7" :show-text="false"></el-progress>
      </div>
    </div>
  </div>
</template>

<script>
  import CountTo from "vue-count-to";
  export default {
    name: "ShopRank",
    components: {CountTo},
    data() {
      return {
        list: [],
        title: "商家收入排行TOP"
      }
    },
    methods: {
      formatPercentage(item, index) {
        if (+this.list[0].count === 0) return 0;
        return index === 0 ? 100 : (item.count / this.list[0].count) * 100
      },
      async getData() {
        let res = await this.$Http.getBillShopRank();
        if (res?.data) {
          let list = res.data.slice(0, 10);
          this.title += list.length;
          this.list = JSON.parse(JSON.stringify(list));
          this.list.forEach(item => item.count = 0);
          this.$nextTick(() => setTimeout(() => this.list = list, 100));
        }
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped lang="scss">
  .shop-rank {
    /deep/ {
      .el-progress-bar__inner {
        transition: width 3s ease!important;
      }
    }
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px;
      .index {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        background-color: #ccc;
        color: #fff;
        border-radius: 50%;
        font-size: 14px;
        &.rank0 {
          background-color: $danger-color;
        }
        &.rank1 {
          background-color: $warn-color;
        }
        &.rank2 {
          background-color: $success-color;
        }
      }
      .content {
        flex: 1;
        margin: 0 10px;
        .tips {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          font-size: 13px;
          margin-bottom: 2px;
          .name {

          }
          .price {
            color: #212121;
          }
        }
      }
    }
  }
</style>
